import React from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import Chart from "react-apexcharts";

export default function PerformanceCard() {

const series = [
{
name: "Performance",
data: [20000, 20000, 35000, 35000, 40000, 60000, 60000]
}
];

const options = {

chart:{
type:"area",
height:270,
toolbar:{show:false},
zoom:{enabled:false}
},

stroke:{
curve:"straight",
width:5,
colors:["#22c55e"]
},

markers:{
size:0
},

dataLabels:{
enabled:false
},

fill:{
type:"gradient",
gradient:{
shade:"light",
type:"vertical",
shadeIntensity:0.5,
gradientToColors:["#22c55e"],
opacityFrom:0.6,
opacityTo:0.1,
stops:[0,100]
}
},

grid:{
borderColor:"#e5e7eb",
strokeDashArray:0,
xaxis:{
lines:{show:false}
},
yaxis:{
lines:{show:true}
}
},

xaxis:{
categories:["Jan","Feb","Mar","Apr","May","Jun","Ju"],
axisBorder:{show:false},
axisTicks:{show:false},
labels:{
style:{
colors:"#6b7280",
fontSize:"13px"
}
}
},

yaxis:{
min:10000,
max:60000,
tickAmount:5,
labels:{
formatter:(val)=> (val/1000)+"K",
style:{
colors:"#6b7280",
fontSize:"13px"
}
}
},

tooltip:{
enabled:true,
theme:"light",
y:{
formatter:(val)=>val
}
}

};

return(

<Card className="flex-fill dashboard-card">

<Card.Header className="d-flex justify-content-between align-items-center card-header-custom">

<h5 className="mb-0">Performance</h5>

<Dropdown>

<Dropdown.Toggle className="year-btn text-dark">
<FiCalendar className="me-1"/>2026
</Dropdown.Toggle>

<Dropdown.Menu align="end">
<Dropdown.Item>2026</Dropdown.Item>
<Dropdown.Item>2025</Dropdown.Item>
<Dropdown.Item>2024</Dropdown.Item>
</Dropdown.Menu>

</Dropdown>

</Card.Header>

<Card.Body>

<div className="performance-box">

<h3 className="me-2 mb-0">98%</h3>

<span className="badge success-badge">12%</span>

<span className="ms-2 text-muted">vs last years</span>

</div>

<Chart
options={options}
series={series}
type="area"
height={270}
/>

</Card.Body>

<style>{`

.dashboard-card{
border-radius:5px;
border:2px solid #e5e7eb;
}

.year-btn{
border:1px solid #e5e7eb;
background:#fff !important;
color:#111827;
font-size:14px;
}
  .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

/* hover color */
.year-btn:hover{
color:#f97316 !important;
background:#fff !important;
}

/* icon color */
.year-btn:hover svg{
color:#f97316 !important;
}

/* remove bootstrap blue focus */
.year-btn:focus,
.year-btn:active{
box-shadow:none !important;
background:#fff !important;
color:#f97316 !important;
}

/* when dropdown is open */
.year-btn.show{
background:#fff !important;
color:#f97316 !important;
box-shadow:none !important;
}
.performance-box{
background:#f3f4f6;
padding:10px 14px;
border-radius:8px;
display:flex;
align-items:center;
margin-bottom:15px;
}

.success-badge{
background:#dcfce7;
color:#16a34a;
padding:3px 10px;
border-radius:20px;
font-size:12px;
}

`}</style>

</Card>

)

}